export const INVENTORY_AUDIT_STATUS = {
  PENDING_SETUP: 'pending_setup',
  IN_PROGRESS: 'in_progress',
  PENDING_APPROVAL: 'pending_approval',
  COMPLETED: 'completed',
  REJECTED_EDITABLE: 'rejected_editable',
  REJECTED_FINAL: 'rejected_final',
} as const;

export const INVENTORY_AUDIT_DETAIL_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
} as const;

export const INVENTORY_AUDIT_RESULT = {
  FOUND: 'Found',
  MISSING: 'Missing',
  NOT_AUDITED: 'not_audited',
  NEW: 'new',
  UPDATED: 'updated',
} as const;

export const INVENTORY_AUDIT_TYPE = {
  FIRST: 'first',
  SUDDEN: 'sudden',
  CAMPAIGN: 'campaign',
} as const;

export const TECHNICAL_CONDITION = {
  NEW: 'new',
  GOOD: 'good',
  FAIR: 'fair',
  POOR: 'poor',
  BAD: 'bad',
  AVERAGE: 'average',
} as const;

export const ASSET_STATUS = {
  IN_USE: 'in_use',
  IN_STORAGE: 'in_storage',
  UNDER_MAINTENANCE: 'under_maintenance',
  DISPOSED: 'disposed',
  LOST: 'lost',
  DAMAGED: 'damaged',
  PENDING_DEPLOYMENT: 'pending_deployment',
} as const;

export const STATUS_COLORS = {
  [INVENTORY_AUDIT_STATUS.PENDING_SETUP]: 'blue',        // Chờ duyệt thực hiện - xanh dương
  [INVENTORY_AUDIT_STATUS.IN_PROGRESS]: 'processing',    // Đang tiến hành - xanh lá
  [INVENTORY_AUDIT_STATUS.PENDING_APPROVAL]: 'orange',   // Chờ duyệt hoàn thành - cam
  [INVENTORY_AUDIT_STATUS.COMPLETED]: 'success',         // Hoàn thành - xanh lá đậm
  [INVENTORY_AUDIT_STATUS.REJECTED_EDITABLE]: 'volcano', // Từ chối (có thể sửa) - đỏ cam
  [INVENTORY_AUDIT_STATUS.REJECTED_FINAL]: 'red',        // Từ chối (không thể sửa) - đỏ
} as const;

export const STATUS_LABELS = {
  [INVENTORY_AUDIT_STATUS.PENDING_SETUP]: 'Chờ duyệt thực hiện',
  [INVENTORY_AUDIT_STATUS.IN_PROGRESS]: 'Đang tiến hành',
  [INVENTORY_AUDIT_STATUS.PENDING_APPROVAL]: 'Chờ duyệt hoàn thành',
  [INVENTORY_AUDIT_STATUS.COMPLETED]: 'Hoàn thành',
  [INVENTORY_AUDIT_STATUS.REJECTED_EDITABLE]: 'Từ chối (có thể sửa)',
  [INVENTORY_AUDIT_STATUS.REJECTED_FINAL]: 'Từ chối (không thể sửa)',
} as const;

export const AUDIT_DETAIL_STATUS_LABELS = {
  [INVENTORY_AUDIT_DETAIL_STATUS.PENDING]: 'Chờ duyệt',
  [INVENTORY_AUDIT_DETAIL_STATUS.APPROVED]: 'Đã duyệt',
} as const;

export const TECHNICAL_CONDITION_LABELS = {
  [TECHNICAL_CONDITION.NEW]: 'Mới',
  [TECHNICAL_CONDITION.GOOD]: 'Tốt',
  [TECHNICAL_CONDITION.FAIR]: 'Khá',
  [TECHNICAL_CONDITION.POOR]: 'Kém',
  [TECHNICAL_CONDITION.BAD]: 'Hỏng',
  [TECHNICAL_CONDITION.AVERAGE]: 'Trung bình',
} as const;

export const ASSET_STATUS_LABELS = {
  [ASSET_STATUS.IN_USE]: 'Đang sử dụng',
  [ASSET_STATUS.IN_STORAGE]: 'Lưu kho',
  [ASSET_STATUS.UNDER_MAINTENANCE]: 'Đang bảo dưỡng',
  [ASSET_STATUS.DISPOSED]: 'Đã thanh lý',
  [ASSET_STATUS.LOST]: 'Mất',
  [ASSET_STATUS.DAMAGED]: 'Hỏng',
  [ASSET_STATUS.PENDING_DEPLOYMENT]: 'Chờ triển khai',
} as const;

export const RESULT_LABELS = {
  [INVENTORY_AUDIT_RESULT.FOUND]: 'Tìm thấy',
  [INVENTORY_AUDIT_RESULT.MISSING]: 'Không tìm thấy',
  [INVENTORY_AUDIT_RESULT.NOT_AUDITED]: 'Chưa kiểm kê',
  [INVENTORY_AUDIT_RESULT.NEW]: 'Mới',
  [INVENTORY_AUDIT_RESULT.UPDATED]: 'Cập nhật',
} as const;

export const TYPE_LABELS = {
  [INVENTORY_AUDIT_TYPE.FIRST]: 'Kiểm kê mới',
  [INVENTORY_AUDIT_TYPE.SUDDEN]: 'Kiểm kê đột xuất',
  [INVENTORY_AUDIT_TYPE.CAMPAIGN]: 'Kiểm kê định kỳ',
} as const;

export const STATUS_OPTIONS = Object.entries(ASSET_STATUS_LABELS).map(([value, label]) => ({
  value,
  label,
}));

export const TECHNICAL_CONDITION_OPTIONS = Object.entries(TECHNICAL_CONDITION_LABELS).map(([value, label]) => ({
  value,
  label,
}));

export const RESULT_OPTIONS = [
  { value: INVENTORY_AUDIT_RESULT.FOUND, label: RESULT_LABELS[INVENTORY_AUDIT_RESULT.FOUND] },
  { value: INVENTORY_AUDIT_RESULT.MISSING, label: RESULT_LABELS[INVENTORY_AUDIT_RESULT.MISSING] },
  { value: INVENTORY_AUDIT_RESULT.NEW, label: RESULT_LABELS[INVENTORY_AUDIT_RESULT.NEW] },
  { value: INVENTORY_AUDIT_RESULT.UPDATED, label: RESULT_LABELS[INVENTORY_AUDIT_RESULT.UPDATED] },
]; 